import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField,Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'


const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props)=>{
    const record = useRecordContext();  
    return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event)=>event.stopPropagation()} />
  )}


const MicrotaskVerifyList = ({ ...props }) => {

    return (
        <List {...props} title="Microtask" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
            <TextField source="id" />
                <ProfileidFiled source="profile_id" label="Profile Id" />  
                <TextField source="name" label="Name" />
                <TextField source="pending_count" label="Pending Count" />
                <TextField source="approved_count" label="Approved Count" />

                <TextField source="rejected_count" label="Rejected Count" />
                <TextField source="total_tasks" label="Total Tasks" />

                <TextField source='created_at' label="Date" />
            </Datagrid>

        </List>
    )
}


export default MicrotaskVerifyList